<template>
  <v-container fluid class="pa-0">
    <div v-if="!iframeUrl" class="d-flex justify-center" style="height: calc(100vh - 100px);">
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </div>
    <div v-else style="position: relative;">
      <iframe
        :src="iframeUrl"
        style="width: 100%; height: calc(100vh - 64px - 48px - 50px); border: 1px solid grey;"
        @load="iframeLoading = false"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import ax from '@/utils/axios/axios'

export default {
  name: 'Xrun',
  data: () => ({
    iframeUrl: null,
    iframeLoading: true
  }),
  async created() {
    try {
      const response = await ax.get('/data/xrun-url')
      this.iframeUrl = `https://www.juoksuodottama.fi?embedCode=${response.data.token}`
    } catch (error) {
      console.error('Failed to fetch run URL token:', error)
      // You might want to show an error message to the user here
    }
  }
}
</script>